module.exports = __webpack_public_path__ + "static/media/Muli-Regular.e063a333.ttf";